/**
 * SilkTale 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#FFF7ED',
  filterColor: '#65686F',
  filterActiveColor: '#FD9540',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
